// This file is auto-generated by @hey-api/openapi-ts

import { type Options, loginUser, logoutUser, whoAmI, requestPasswordReset, resetPassword, setInitialPassword, getAllCustomers, createCustomer, deleteCustomer, getCustomerById, updateCustomer, syncCart, getAllMachines, getCustomerMachines, createMachineForCustomer, deleteMachine, getMachineById, updateMachine, updateMachineWeeklyChecklistDigest, upsertMachinePreview, upsertMachineBom, getPreviewImageForItem, upsertInventoryPreview, getHubspotCompanyById, getHubspotContactById, getAllLangguthUsers, createLangguthUser, deleteLangguthUser, getLangguthUserById, updateLangguthUser, resendLangguthUserInvite, getAllCustomerUsers, getAllCustomerUsersForCustomer, createCustomerUser, resendCustomerUserInvite, deleteCustomerUser, getCustomerUserById, updateCustomerUser, getAllRequests, getAllRequestsForCustomer, createRequest, deleteRequest, getRequestForCustomerById } from '../sdk.gen';
import { queryOptions, type UseMutationOptions, type DefaultError, infiniteQueryOptions, type InfiniteData } from '@tanstack/react-query';
import type { LoginUserData, LoginUserResponse, LogoutUserData, LogoutUserResponse, WhoAmIData, RequestPasswordResetData, RequestPasswordResetResponse, ResetPasswordData, ResetPasswordResponse, SetInitialPasswordData, SetInitialPasswordResponse, GetAllCustomersData, GetAllCustomersResponse, CreateCustomerData, CreateCustomerResponse, DeleteCustomerData, DeleteCustomerResponse, GetCustomerByIdData, UpdateCustomerData, UpdateCustomerResponse, SyncCartData, GetAllMachinesData, GetAllMachinesResponse, GetCustomerMachinesData, CreateMachineForCustomerData, CreateMachineForCustomerResponse, DeleteMachineData, DeleteMachineResponse, GetMachineByIdData, UpdateMachineData, UpdateMachineResponse, UpdateMachineWeeklyChecklistDigestData, UpdateMachineWeeklyChecklistDigestResponse, UpsertMachinePreviewData, UpsertMachinePreviewResponse, UpsertMachineBomData, UpsertMachineBomResponse, GetPreviewImageForItemData, UpsertInventoryPreviewData, UpsertInventoryPreviewResponse, GetHubspotCompanyByIdData, GetHubspotContactByIdData, GetAllLangguthUsersData, GetAllLangguthUsersResponse, CreateLangguthUserData, CreateLangguthUserResponse, DeleteLangguthUserData, DeleteLangguthUserResponse, GetLangguthUserByIdData, UpdateLangguthUserData, UpdateLangguthUserResponse, ResendLangguthUserInviteData, ResendLangguthUserInviteResponse, GetAllCustomerUsersData, GetAllCustomerUsersResponse, GetAllCustomerUsersForCustomerData, GetAllCustomerUsersForCustomerResponse, CreateCustomerUserData, CreateCustomerUserResponse, ResendCustomerUserInviteData, ResendCustomerUserInviteResponse, DeleteCustomerUserData, DeleteCustomerUserResponse, GetCustomerUserByIdData, UpdateCustomerUserData, UpdateCustomerUserResponse, GetAllRequestsData, GetAllRequestsResponse, GetAllRequestsForCustomerData, GetAllRequestsForCustomerResponse, CreateRequestData, CreateRequestResponse2, DeleteRequestData, DeleteRequestResponse, GetRequestForCustomerByIdData } from '../types.gen';
import { client as _heyApiClient } from '../client.gen';

export type QueryKey<TOptions extends Options> = [
    Pick<TOptions, 'baseUrl' | 'body' | 'headers' | 'path' | 'query'> & {
        _id: string;
        _infinite?: boolean;
    }
];

const createQueryKey = <TOptions extends Options>(id: string, options?: TOptions, infinite?: boolean): [
    QueryKey<TOptions>[0]
] => {
    const params: QueryKey<TOptions>[0] = { _id: id, baseUrl: (options?.client ?? _heyApiClient).getConfig().baseUrl } as QueryKey<TOptions>[0];
    if (infinite) {
        params._infinite = infinite;
    }
    if (options?.body) {
        params.body = options.body;
    }
    if (options?.headers) {
        params.headers = options.headers;
    }
    if (options?.path) {
        params.path = options.path;
    }
    if (options?.query) {
        params.query = options.query;
    }
    return [
        params
    ];
};

export const loginUserQueryKey = (options?: Options<LoginUserData>) => createQueryKey('loginUser', options);

/**
 * Login the user
 */
export const loginUserOptions = (options?: Options<LoginUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await loginUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: loginUserQueryKey(options)
    });
};

/**
 * Login the user
 */
export const loginUserMutation = (options?: Partial<Options<LoginUserData>>): UseMutationOptions<LoginUserResponse, DefaultError, Options<LoginUserData>> => {
    const mutationOptions: UseMutationOptions<LoginUserResponse, DefaultError, Options<LoginUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await loginUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const logoutUserQueryKey = (options?: Options<LogoutUserData>) => createQueryKey('logoutUser', options);

/**
 * Logout the user
 */
export const logoutUserOptions = (options?: Options<LogoutUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await logoutUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: logoutUserQueryKey(options)
    });
};

/**
 * Logout the user
 */
export const logoutUserMutation = (options?: Partial<Options<LogoutUserData>>): UseMutationOptions<LogoutUserResponse, DefaultError, Options<LogoutUserData>> => {
    const mutationOptions: UseMutationOptions<LogoutUserResponse, DefaultError, Options<LogoutUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await logoutUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const whoAmIQueryKey = (options?: Options<WhoAmIData>) => createQueryKey('whoAmI', options);

/**
 * Get information about authentication status
 */
export const whoAmIOptions = (options?: Options<WhoAmIData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await whoAmI({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: whoAmIQueryKey(options)
    });
};

export const requestPasswordResetQueryKey = (options?: Options<RequestPasswordResetData>) => createQueryKey('requestPasswordReset', options);

/**
 * Request a password reset for a user
 */
export const requestPasswordResetOptions = (options?: Options<RequestPasswordResetData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await requestPasswordReset({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: requestPasswordResetQueryKey(options)
    });
};

/**
 * Request a password reset for a user
 */
export const requestPasswordResetMutation = (options?: Partial<Options<RequestPasswordResetData>>): UseMutationOptions<RequestPasswordResetResponse, DefaultError, Options<RequestPasswordResetData>> => {
    const mutationOptions: UseMutationOptions<RequestPasswordResetResponse, DefaultError, Options<RequestPasswordResetData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await requestPasswordReset({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resetPasswordQueryKey = (options?: Options<ResetPasswordData>) => createQueryKey('resetPassword', options);

/**
 * Reset password using a reset token
 */
export const resetPasswordOptions = (options?: Options<ResetPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resetPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resetPasswordQueryKey(options)
    });
};

/**
 * Reset password using a reset token
 */
export const resetPasswordMutation = (options?: Partial<Options<ResetPasswordData>>): UseMutationOptions<ResetPasswordResponse, DefaultError, Options<ResetPasswordData>> => {
    const mutationOptions: UseMutationOptions<ResetPasswordResponse, DefaultError, Options<ResetPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resetPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const setInitialPasswordQueryKey = (options?: Options<SetInitialPasswordData>) => createQueryKey('setInitialPassword', options);

/**
 * Set initial password using a setup token
 */
export const setInitialPasswordOptions = (options?: Options<SetInitialPasswordData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await setInitialPassword({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: setInitialPasswordQueryKey(options)
    });
};

/**
 * Set initial password using a setup token
 */
export const setInitialPasswordMutation = (options?: Partial<Options<SetInitialPasswordData>>): UseMutationOptions<SetInitialPasswordResponse, DefaultError, Options<SetInitialPasswordData>> => {
    const mutationOptions: UseMutationOptions<SetInitialPasswordResponse, DefaultError, Options<SetInitialPasswordData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await setInitialPassword({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllCustomersQueryKey = (options?: Options<GetAllCustomersData>) => createQueryKey('getAllCustomers', options);

/**
 * Get all customers
 */
export const getAllCustomersOptions = (options?: Options<GetAllCustomersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCustomers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomersQueryKey(options)
    });
};

const createInfiniteParams = <K extends Pick<QueryKey<Options>[0], 'body' | 'headers' | 'path' | 'query'>>(queryKey: QueryKey<Options>, page: K) => {
    const params = {
        ...queryKey[0]
    };
    if (page.body) {
        params.body = {
            ...queryKey[0].body as any,
            ...page.body as any
        };
    }
    if (page.headers) {
        params.headers = {
            ...queryKey[0].headers,
            ...page.headers
        };
    }
    if (page.path) {
        params.path = {
            ...queryKey[0].path as any,
            ...page.path as any
        };
    }
    if (page.query) {
        params.query = {
            ...queryKey[0].query as any,
            ...page.query as any
        };
    }
    return params as unknown as typeof page;
};

export const getAllCustomersInfiniteQueryKey = (options?: Options<GetAllCustomersData>): QueryKey<Options<GetAllCustomersData>> => createQueryKey('getAllCustomers', options, true);

/**
 * Get all customers
 */
export const getAllCustomersInfiniteOptions = (options?: Options<GetAllCustomersData>) => {
    return infiniteQueryOptions<GetAllCustomersResponse, DefaultError, InfiniteData<GetAllCustomersResponse>, QueryKey<Options<GetAllCustomersData>>, number | Pick<QueryKey<Options<GetAllCustomersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllCustomersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllCustomers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomersInfiniteQueryKey(options)
    });
};

export const createCustomerQueryKey = (options?: Options<CreateCustomerData>) => createQueryKey('createCustomer', options);

/**
 * Create a new customer
 */
export const createCustomerOptions = (options?: Options<CreateCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCustomerQueryKey(options)
    });
};

/**
 * Create a new customer
 */
export const createCustomerMutation = (options?: Partial<Options<CreateCustomerData>>): UseMutationOptions<CreateCustomerResponse, DefaultError, Options<CreateCustomerData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomerResponse, DefaultError, Options<CreateCustomerData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCustomer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a customer
 */
export const deleteCustomerMutation = (options?: Partial<Options<DeleteCustomerData>>): UseMutationOptions<DeleteCustomerResponse, DefaultError, Options<DeleteCustomerData>> => {
    const mutationOptions: UseMutationOptions<DeleteCustomerResponse, DefaultError, Options<DeleteCustomerData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteCustomer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomerByIdQueryKey = (options: Options<GetCustomerByIdData>) => createQueryKey('getCustomerById', options);

/**
 * Get a customer by ID
 */
export const getCustomerByIdOptions = (options: Options<GetCustomerByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomerById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCustomerByIdQueryKey(options)
    });
};

/**
 * Update a customer
 */
export const updateCustomerMutation = (options?: Partial<Options<UpdateCustomerData>>): UseMutationOptions<UpdateCustomerResponse, DefaultError, Options<UpdateCustomerData>> => {
    const mutationOptions: UseMutationOptions<UpdateCustomerResponse, DefaultError, Options<UpdateCustomerData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCustomer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Synchronize the entire cart state (fire-and-forget tracking)
 */
export const syncCartMutation = (options?: Partial<Options<SyncCartData>>): UseMutationOptions<unknown, DefaultError, Options<SyncCartData>> => {
    const mutationOptions: UseMutationOptions<unknown, DefaultError, Options<SyncCartData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await syncCart({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllMachinesQueryKey = (options?: Options<GetAllMachinesData>) => createQueryKey('getAllMachines', options);

/**
 * Get all machines
 */
export const getAllMachinesOptions = (options?: Options<GetAllMachinesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllMachines({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllMachinesQueryKey(options)
    });
};

export const getAllMachinesInfiniteQueryKey = (options?: Options<GetAllMachinesData>): QueryKey<Options<GetAllMachinesData>> => createQueryKey('getAllMachines', options, true);

/**
 * Get all machines
 */
export const getAllMachinesInfiniteOptions = (options?: Options<GetAllMachinesData>) => {
    return infiniteQueryOptions<GetAllMachinesResponse, DefaultError, InfiniteData<GetAllMachinesResponse>, QueryKey<Options<GetAllMachinesData>>, number | Pick<QueryKey<Options<GetAllMachinesData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllMachinesData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllMachines({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllMachinesInfiniteQueryKey(options)
    });
};

export const getCustomerMachinesQueryKey = (options: Options<GetCustomerMachinesData>) => createQueryKey('getCustomerMachines', options);

/**
 * Get all machines for a customer
 */
export const getCustomerMachinesOptions = (options: Options<GetCustomerMachinesData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomerMachines({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCustomerMachinesQueryKey(options)
    });
};

export const createMachineForCustomerQueryKey = (options: Options<CreateMachineForCustomerData>) => createQueryKey('createMachineForCustomer', options);

/**
 * Create a new machine for a customer
 */
export const createMachineForCustomerOptions = (options: Options<CreateMachineForCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createMachineForCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createMachineForCustomerQueryKey(options)
    });
};

/**
 * Create a new machine for a customer
 */
export const createMachineForCustomerMutation = (options?: Partial<Options<CreateMachineForCustomerData>>): UseMutationOptions<CreateMachineForCustomerResponse, DefaultError, Options<CreateMachineForCustomerData>> => {
    const mutationOptions: UseMutationOptions<CreateMachineForCustomerResponse, DefaultError, Options<CreateMachineForCustomerData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createMachineForCustomer({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a machine
 */
export const deleteMachineMutation = (options?: Partial<Options<DeleteMachineData>>): UseMutationOptions<DeleteMachineResponse, DefaultError, Options<DeleteMachineData>> => {
    const mutationOptions: UseMutationOptions<DeleteMachineResponse, DefaultError, Options<DeleteMachineData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteMachine({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getMachineByIdQueryKey = (options: Options<GetMachineByIdData>) => createQueryKey('getMachineById', options);

/**
 * Get a machine by ID
 */
export const getMachineByIdOptions = (options: Options<GetMachineByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getMachineById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getMachineByIdQueryKey(options)
    });
};

/**
 * Update a machine
 */
export const updateMachineMutation = (options?: Partial<Options<UpdateMachineData>>): UseMutationOptions<UpdateMachineResponse, DefaultError, Options<UpdateMachineData>> => {
    const mutationOptions: UseMutationOptions<UpdateMachineResponse, DefaultError, Options<UpdateMachineData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateMachine({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Update weekly checklist digest email settings for a machine
 */
export const updateMachineWeeklyChecklistDigestMutation = (options?: Partial<Options<UpdateMachineWeeklyChecklistDigestData>>): UseMutationOptions<UpdateMachineWeeklyChecklistDigestResponse, DefaultError, Options<UpdateMachineWeeklyChecklistDigestData>> => {
    const mutationOptions: UseMutationOptions<UpdateMachineWeeklyChecklistDigestResponse, DefaultError, Options<UpdateMachineWeeklyChecklistDigestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateMachineWeeklyChecklistDigest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert the preview image for a machine
 */
export const upsertMachinePreviewMutation = (options?: Partial<Options<UpsertMachinePreviewData>>): UseMutationOptions<UpsertMachinePreviewResponse, DefaultError, Options<UpsertMachinePreviewData>> => {
    const mutationOptions: UseMutationOptions<UpsertMachinePreviewResponse, DefaultError, Options<UpsertMachinePreviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await upsertMachinePreview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Upsert the bill of materials for a machine
 */
export const upsertMachineBomMutation = (options?: Partial<Options<UpsertMachineBomData>>): UseMutationOptions<UpsertMachineBomResponse, DefaultError, Options<UpsertMachineBomData>> => {
    const mutationOptions: UseMutationOptions<UpsertMachineBomResponse, DefaultError, Options<UpsertMachineBomData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await upsertMachineBom({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getPreviewImageForItemQueryKey = (options: Options<GetPreviewImageForItemData>) => createQueryKey('getPreviewImageForItem', options);

/**
 * Get the preview image information for an inventory item
 */
export const getPreviewImageForItemOptions = (options: Options<GetPreviewImageForItemData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getPreviewImageForItem({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getPreviewImageForItemQueryKey(options)
    });
};

/**
 * Upsert the preview image for an inventory item
 */
export const upsertInventoryPreviewMutation = (options?: Partial<Options<UpsertInventoryPreviewData>>): UseMutationOptions<UpsertInventoryPreviewResponse, DefaultError, Options<UpsertInventoryPreviewData>> => {
    const mutationOptions: UseMutationOptions<UpsertInventoryPreviewResponse, DefaultError, Options<UpsertInventoryPreviewData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await upsertInventoryPreview({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getHubspotCompanyByIdQueryKey = (options: Options<GetHubspotCompanyByIdData>) => createQueryKey('getHubspotCompanyById', options);

/**
 * Get HubSpot company name by ID
 */
export const getHubspotCompanyByIdOptions = (options: Options<GetHubspotCompanyByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHubspotCompanyById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHubspotCompanyByIdQueryKey(options)
    });
};

export const getHubspotContactByIdQueryKey = (options: Options<GetHubspotContactByIdData>) => createQueryKey('getHubspotContactById', options);

/**
 * Get HubSpot contact name by ID
 */
export const getHubspotContactByIdOptions = (options: Options<GetHubspotContactByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getHubspotContactById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getHubspotContactByIdQueryKey(options)
    });
};

export const getAllLangguthUsersQueryKey = (options?: Options<GetAllLangguthUsersData>) => createQueryKey('getAllLangguthUsers', options);

/**
 * Get all Langguth users
 */
export const getAllLangguthUsersOptions = (options?: Options<GetAllLangguthUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllLangguthUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllLangguthUsersQueryKey(options)
    });
};

export const getAllLangguthUsersInfiniteQueryKey = (options?: Options<GetAllLangguthUsersData>): QueryKey<Options<GetAllLangguthUsersData>> => createQueryKey('getAllLangguthUsers', options, true);

/**
 * Get all Langguth users
 */
export const getAllLangguthUsersInfiniteOptions = (options?: Options<GetAllLangguthUsersData>) => {
    return infiniteQueryOptions<GetAllLangguthUsersResponse, DefaultError, InfiniteData<GetAllLangguthUsersResponse>, QueryKey<Options<GetAllLangguthUsersData>>, number | Pick<QueryKey<Options<GetAllLangguthUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllLangguthUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllLangguthUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllLangguthUsersInfiniteQueryKey(options)
    });
};

export const createLangguthUserQueryKey = (options?: Options<CreateLangguthUserData>) => createQueryKey('createLangguthUser', options);

/**
 * Create a new Langguth user
 */
export const createLangguthUserOptions = (options?: Options<CreateLangguthUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createLangguthUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createLangguthUserQueryKey(options)
    });
};

/**
 * Create a new Langguth user
 */
export const createLangguthUserMutation = (options?: Partial<Options<CreateLangguthUserData>>): UseMutationOptions<CreateLangguthUserResponse, DefaultError, Options<CreateLangguthUserData>> => {
    const mutationOptions: UseMutationOptions<CreateLangguthUserResponse, DefaultError, Options<CreateLangguthUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createLangguthUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a Langguth user
 */
export const deleteLangguthUserMutation = (options?: Partial<Options<DeleteLangguthUserData>>): UseMutationOptions<DeleteLangguthUserResponse, DefaultError, Options<DeleteLangguthUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteLangguthUserResponse, DefaultError, Options<DeleteLangguthUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteLangguthUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getLangguthUserByIdQueryKey = (options: Options<GetLangguthUserByIdData>) => createQueryKey('getLangguthUserById', options);

/**
 * Get a Langguth user by ID
 */
export const getLangguthUserByIdOptions = (options: Options<GetLangguthUserByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getLangguthUserById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getLangguthUserByIdQueryKey(options)
    });
};

/**
 * Update a Langguth user
 */
export const updateLangguthUserMutation = (options?: Partial<Options<UpdateLangguthUserData>>): UseMutationOptions<UpdateLangguthUserResponse, DefaultError, Options<UpdateLangguthUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateLangguthUserResponse, DefaultError, Options<UpdateLangguthUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateLangguthUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendLangguthUserInviteQueryKey = (options: Options<ResendLangguthUserInviteData>) => createQueryKey('resendLangguthUserInvite', options);

/**
 * Resend new-user setup invite email
 */
export const resendLangguthUserInviteOptions = (options: Options<ResendLangguthUserInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendLangguthUserInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendLangguthUserInviteQueryKey(options)
    });
};

/**
 * Resend new-user setup invite email
 */
export const resendLangguthUserInviteMutation = (options?: Partial<Options<ResendLangguthUserInviteData>>): UseMutationOptions<ResendLangguthUserInviteResponse, DefaultError, Options<ResendLangguthUserInviteData>> => {
    const mutationOptions: UseMutationOptions<ResendLangguthUserInviteResponse, DefaultError, Options<ResendLangguthUserInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendLangguthUserInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllCustomerUsersQueryKey = (options?: Options<GetAllCustomerUsersData>) => createQueryKey('getAllCustomerUsers', options);

/**
 * Get all customer users
 */
export const getAllCustomerUsersOptions = (options?: Options<GetAllCustomerUsersData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCustomerUsers({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomerUsersQueryKey(options)
    });
};

export const getAllCustomerUsersInfiniteQueryKey = (options?: Options<GetAllCustomerUsersData>): QueryKey<Options<GetAllCustomerUsersData>> => createQueryKey('getAllCustomerUsers', options, true);

/**
 * Get all customer users
 */
export const getAllCustomerUsersInfiniteOptions = (options?: Options<GetAllCustomerUsersData>) => {
    return infiniteQueryOptions<GetAllCustomerUsersResponse, DefaultError, InfiniteData<GetAllCustomerUsersResponse>, QueryKey<Options<GetAllCustomerUsersData>>, number | Pick<QueryKey<Options<GetAllCustomerUsersData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllCustomerUsersData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllCustomerUsers({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomerUsersInfiniteQueryKey(options)
    });
};

export const getAllCustomerUsersForCustomerQueryKey = (options: Options<GetAllCustomerUsersForCustomerData>) => createQueryKey('getAllCustomerUsersForCustomer', options);

/**
 * Get all customer users for a customer
 */
export const getAllCustomerUsersForCustomerOptions = (options: Options<GetAllCustomerUsersForCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllCustomerUsersForCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomerUsersForCustomerQueryKey(options)
    });
};

export const getAllCustomerUsersForCustomerInfiniteQueryKey = (options: Options<GetAllCustomerUsersForCustomerData>): QueryKey<Options<GetAllCustomerUsersForCustomerData>> => createQueryKey('getAllCustomerUsersForCustomer', options, true);

/**
 * Get all customer users for a customer
 */
export const getAllCustomerUsersForCustomerInfiniteOptions = (options: Options<GetAllCustomerUsersForCustomerData>) => {
    return infiniteQueryOptions<GetAllCustomerUsersForCustomerResponse, DefaultError, InfiniteData<GetAllCustomerUsersForCustomerResponse>, QueryKey<Options<GetAllCustomerUsersForCustomerData>>, number | Pick<QueryKey<Options<GetAllCustomerUsersForCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllCustomerUsersForCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllCustomerUsersForCustomer({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllCustomerUsersForCustomerInfiniteQueryKey(options)
    });
};

export const createCustomerUserQueryKey = (options: Options<CreateCustomerUserData>) => createQueryKey('createCustomerUser', options);

/**
 * Create a new customer user
 */
export const createCustomerUserOptions = (options: Options<CreateCustomerUserData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createCustomerUser({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createCustomerUserQueryKey(options)
    });
};

/**
 * Create a new customer user
 */
export const createCustomerUserMutation = (options?: Partial<Options<CreateCustomerUserData>>): UseMutationOptions<CreateCustomerUserResponse, DefaultError, Options<CreateCustomerUserData>> => {
    const mutationOptions: UseMutationOptions<CreateCustomerUserResponse, DefaultError, Options<CreateCustomerUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createCustomerUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const resendCustomerUserInviteQueryKey = (options: Options<ResendCustomerUserInviteData>) => createQueryKey('resendCustomerUserInvite', options);

/**
 * Resend new-user setup invite email
 */
export const resendCustomerUserInviteOptions = (options: Options<ResendCustomerUserInviteData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await resendCustomerUserInvite({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: resendCustomerUserInviteQueryKey(options)
    });
};

/**
 * Resend new-user setup invite email
 */
export const resendCustomerUserInviteMutation = (options?: Partial<Options<ResendCustomerUserInviteData>>): UseMutationOptions<ResendCustomerUserInviteResponse, DefaultError, Options<ResendCustomerUserInviteData>> => {
    const mutationOptions: UseMutationOptions<ResendCustomerUserInviteResponse, DefaultError, Options<ResendCustomerUserInviteData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await resendCustomerUserInvite({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a customer user
 */
export const deleteCustomerUserMutation = (options?: Partial<Options<DeleteCustomerUserData>>): UseMutationOptions<DeleteCustomerUserResponse, DefaultError, Options<DeleteCustomerUserData>> => {
    const mutationOptions: UseMutationOptions<DeleteCustomerUserResponse, DefaultError, Options<DeleteCustomerUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteCustomerUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getCustomerUserByIdQueryKey = (options: Options<GetCustomerUserByIdData>) => createQueryKey('getCustomerUserById', options);

/**
 * Get a customer user by ID
 */
export const getCustomerUserByIdOptions = (options: Options<GetCustomerUserByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getCustomerUserById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getCustomerUserByIdQueryKey(options)
    });
};

/**
 * Update a customer user
 */
export const updateCustomerUserMutation = (options?: Partial<Options<UpdateCustomerUserData>>): UseMutationOptions<UpdateCustomerUserResponse, DefaultError, Options<UpdateCustomerUserData>> => {
    const mutationOptions: UseMutationOptions<UpdateCustomerUserResponse, DefaultError, Options<UpdateCustomerUserData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await updateCustomerUser({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getAllRequestsQueryKey = (options?: Options<GetAllRequestsData>) => createQueryKey('getAllRequests', options);

/**
 * Get all spare parts requests
 */
export const getAllRequestsOptions = (options?: Options<GetAllRequestsData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllRequests({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllRequestsQueryKey(options)
    });
};

export const getAllRequestsInfiniteQueryKey = (options?: Options<GetAllRequestsData>): QueryKey<Options<GetAllRequestsData>> => createQueryKey('getAllRequests', options, true);

/**
 * Get all spare parts requests
 */
export const getAllRequestsInfiniteOptions = (options?: Options<GetAllRequestsData>) => {
    return infiniteQueryOptions<GetAllRequestsResponse, DefaultError, InfiniteData<GetAllRequestsResponse>, QueryKey<Options<GetAllRequestsData>>, number | Pick<QueryKey<Options<GetAllRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllRequestsData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllRequests({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllRequestsInfiniteQueryKey(options)
    });
};

export const getAllRequestsForCustomerQueryKey = (options: Options<GetAllRequestsForCustomerData>) => createQueryKey('getAllRequestsForCustomer', options);

/**
 * Get all spare parts requests for a customer
 */
export const getAllRequestsForCustomerOptions = (options: Options<GetAllRequestsForCustomerData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getAllRequestsForCustomer({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllRequestsForCustomerQueryKey(options)
    });
};

export const getAllRequestsForCustomerInfiniteQueryKey = (options: Options<GetAllRequestsForCustomerData>): QueryKey<Options<GetAllRequestsForCustomerData>> => createQueryKey('getAllRequestsForCustomer', options, true);

/**
 * Get all spare parts requests for a customer
 */
export const getAllRequestsForCustomerInfiniteOptions = (options: Options<GetAllRequestsForCustomerData>) => {
    return infiniteQueryOptions<GetAllRequestsForCustomerResponse, DefaultError, InfiniteData<GetAllRequestsForCustomerResponse>, QueryKey<Options<GetAllRequestsForCustomerData>>, number | Pick<QueryKey<Options<GetAllRequestsForCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'>>(
    // @ts-ignore
    {
        queryFn: async ({ pageParam, queryKey, signal }) => {
            // @ts-ignore
            const page: Pick<QueryKey<Options<GetAllRequestsForCustomerData>>[0], 'body' | 'headers' | 'path' | 'query'> = typeof pageParam === 'object' ? pageParam : {
                query: {
                    page: pageParam
                }
            };
            const params = createInfiniteParams(queryKey, page);
            const { data } = await getAllRequestsForCustomer({
                ...options,
                ...params,
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getAllRequestsForCustomerInfiniteQueryKey(options)
    });
};

export const createRequestQueryKey = (options: Options<CreateRequestData>) => createQueryKey('createRequest', options);

/**
 * Create a new spare parts request for a customer
 */
export const createRequestOptions = (options: Options<CreateRequestData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await createRequest({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: createRequestQueryKey(options)
    });
};

/**
 * Create a new spare parts request for a customer
 */
export const createRequestMutation = (options?: Partial<Options<CreateRequestData>>): UseMutationOptions<CreateRequestResponse2, DefaultError, Options<CreateRequestData>> => {
    const mutationOptions: UseMutationOptions<CreateRequestResponse2, DefaultError, Options<CreateRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await createRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

/**
 * Delete a spare parts request
 */
export const deleteRequestMutation = (options?: Partial<Options<DeleteRequestData>>): UseMutationOptions<DeleteRequestResponse, DefaultError, Options<DeleteRequestData>> => {
    const mutationOptions: UseMutationOptions<DeleteRequestResponse, DefaultError, Options<DeleteRequestData>> = {
        mutationFn: async (localOptions) => {
            const { data } = await deleteRequest({
                ...options,
                ...localOptions,
                throwOnError: true
            });
            return data;
        }
    };
    return mutationOptions;
};

export const getRequestForCustomerByIdQueryKey = (options: Options<GetRequestForCustomerByIdData>) => createQueryKey('getRequestForCustomerById', options);

/**
 * Get a spare parts request for a customer by ID
 */
export const getRequestForCustomerByIdOptions = (options: Options<GetRequestForCustomerByIdData>) => {
    return queryOptions({
        queryFn: async ({ queryKey, signal }) => {
            const { data } = await getRequestForCustomerById({
                ...options,
                ...queryKey[0],
                signal,
                throwOnError: true
            });
            return data;
        },
        queryKey: getRequestForCustomerByIdQueryKey(options)
    });
};